import { render, staticRenderFns } from "./studentRemark.vue?vue&type=template&id=04fe0a1c&scoped=true"
import script from "./studentRemark.vue?vue&type=script&lang=js"
export * from "./studentRemark.vue?vue&type=script&lang=js"
import style0 from "./studentRemark.vue?vue&type=style&index=0&id=04fe0a1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04fe0a1c",
  null
  
)

export default component.exports